import { ENDPOINTS } from "./networkConfig";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { LOCAL_AUTH_STATE_KEY } from "src/utils/appConstants";
import { store } from "src/state/store/store";
import { userLogout } from "src/state/slices/authSlice";
const getAuthToken = () => {
  let res = localStorage.getItem(LOCAL_AUTH_STATE_KEY);
  if (!res) {
    toast.error("Failed to fetch Auth Token from local storage", {
      position: "top-right",
      autoClose: 3000,
    });
    return null;
  }
  let data = JSON.parse(res);
  if (data?.auth?.linkedToken) {
    if (data?.auth?.activeAccount == "reviewer") {
      return data?.auth?.token;
    } else if (data?.auth?.activeAccount == "author") {
      return data?.auth?.linkedToken;
    }
  } else {
    return data?.auth?.token;
  }
};

const commonHeaders = () => {
  const token = getAuthToken();
  if (!token) {
    throw new Error("Missing authentication token.");
  }
  return {
    Authorization: `${token}`,
    "Content-Type": "multipart/form-data",
  };
};

export const loginApi = async (loginDetails) => {
  const formData = new FormData();
  formData.append("email", loginDetails.email);
  formData.append("password", loginDetails.password);
  formData.append("type", loginDetails.type);

  let response = await axios({
    method: "post",
    url: ENDPOINTS.login,
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response;
};

export const contactApi = async (contactDetails) => {
  const formData = new FormData();
  formData.append("name", contactDetails.name);
  formData.append("email", contactDetails.email);
  formData.append("message", contactDetails.message);

  let response = await axios({
    method: "post",
    url: ENDPOINTS.contact,
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response;
};

export const registerApi = async (registrationDetails) => {
  const formData = new FormData();
  formData.append("name", registrationDetails.name);
  formData.append("email", registrationDetails.email);
  formData.append("contact", registrationDetails.contact);
  formData.append("password", registrationDetails.password);
  formData.append("type", registrationDetails.type);

  let response = await axios({
    method: "post",
    url: ENDPOINTS.register,
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return response;
};

export const getJournalApi = async () => {
  const response = await axios({
    method: "get",
    url: ENDPOINTS.manageJournal,
    headers: commonHeaders(),
  });

  return response.data;
};

// Create Journal API
export const createJournalApi = async (journalDetails) => {
  let response = await axios({
    method: "post",
    url: ENDPOINTS.create_journal,
    data: journalDetails,
    headers: commonHeaders(),
  });
  return response;
};

export const deleteJournalApi = async (id) => {
  if (!id) {
    throw new Error("Journal ID is missing.");
  }

  const response = await axios.get(`${ENDPOINTS.deleteJournal}/${id}`, {
    headers: commonHeaders(),
  });

  return response.data;
};

export const updateJournalApi = async (journalId, payload) => {
  let response = await axios({
    method: "post",
    url: `${ENDPOINTS.updateJournal}/${journalId}`,
    data: payload,
    headers: commonHeaders(),
  });
  return response;
};

export const getJournalByIdApi = async (journalId) => {
  let response = await axios({
    method: "get",
    url: `${ENDPOINTS.getJournalByItsId}/${journalId}`,
    headers: commonHeaders(),
  });

  console.log("Update response:", response.data);
  return response;
};

export const getReviewerSearchApi = async () => {
  try {
    const response = await axios.post(ENDPOINTS.searchReviewer);
    console.log("Update response:", response.data);
    return response.data;
  } catch (error) {
    console.error("Failed to update journal:", error);
    throw error;
  }
};

export const getAuthorDetailsApi = async () => {
  let response = await axios({
    method: "get",
    url: ENDPOINTS.getPersonalDetails,
    headers: commonHeaders(),
  });
  if (response.data.status != 200) {
    store.dispatch(userLogout());
  }
  return response.data;
};

export const reviewerSearchApi = async (filters) => {
  let response = await axios({
    method: "get",
    url: `${ENDPOINTS.reviewerSearch}/${filters.limit}/${filters.offset}?search=${filters.name}&country=${filters.country}&department=${filters.department}`,
  });
  return response;
};
export const reviewerSearchAsPublisherApi = async (filters) => {
  let response = await axios({
    method: "get",
    url: `${ENDPOINTS.reviewerSearchAsPublisher}/${filters.limit}/${filters.offset}?search=${filters.name}&country=${filters.country}&department=${filters.department}`,
    headers: commonHeaders(),
  });
  return response;
};
export const getCountriesApi = async () => {
  let response = await axios({
    method: "get",
    url: ENDPOINTS.getCountries,
  });
  return response;
};

export const updateAuthorProfileApi = async (id, profileData) => {
  let response = await axios({
    method: "post",
    url: `${ENDPOINTS.updateAuthorProfile}/${id}`,
    data: profileData,
    headers: commonHeaders(),
  });
  console.log("Update response:", response.data);
  return response.data;
};

export const updatePRDocumentApi = async (formdata) => {
  let response = await axios({
    method: "post",
    url: `${ENDPOINTS.updatePRDocument}`,
    data: formdata,
    headers: commonHeaders(),
  });
  console.log("Update response:", response.data);
  return response;
};

export const getStatesApi = async (id) => {
  let response = await axios({
    method: "get",
    url: `${ENDPOINTS.getStates}/${id}`,
  });
  return response;
};

export const getReviewerById = async (id) => {
  let response = await axios({
    method: "get",
    url: `${ENDPOINTS.getReviewerById}/${id}`,
  });
  return response;
};

export const journalSearchApi = async (filters) => {
  let response = await axios({
    method: "get",
    url: `${ENDPOINTS.journalSearch}/${filters.limit}/${filters.offset}?search=${filters.name}&country=${filters.country}&publication_type=${filters.publication_type}&number_of_issue_per_year=${filters.number_of_issue_per_year}&review_type=${filters.review_type}`,
  });
  return response;
};

export const createPublicationApi = async (data) => {
  let response = await axios({
    method: "post",
    url: `${ENDPOINTS.createPublication}`,
    data: data,
    headers: commonHeaders(),
  });
  return response;
};

export const getPublicationApi = async () => {
  let response = await axios({
    method: "get",
    url: `${ENDPOINTS.getPublication}`,
    headers: commonHeaders(),
  });
  return response;
};

export const deletePublicationApi = async (id) => {
  let response = await axios({
    method: "get",
    url: `${ENDPOINTS.deletePublication}/${id}`,
    headers: commonHeaders(),
  });
  return response;
};

export const submitResearchPaperApi = async (formData) => {
  let response = await axios({
    method: "post",
    url: ENDPOINTS.submitResearchPaper,
    data: formData,
    headers: commonHeaders(),
  });
  return response;
};
export const getPublicationByIdApi = async (id) => {
  let response = await axios({
    method: "get",
    url: `${ENDPOINTS.getPublicationById}/${id}`,
    headers: commonHeaders(),
  });
  return response;
};

export const updatePublicationApi = async (id, data) => {
  let response = await axios({
    method: "post",
    url: `${ENDPOINTS.updatePublication}/${id}`,
    data: data,
    headers: commonHeaders(),
  });
  return response;
};

export const getReviewerRequestsApi = async () => {
  let response = await axios({
    method: "get",
    url: `${ENDPOINTS.reviewerRequests}`,

    headers: commonHeaders(),
  });
  return response;
};

export const getPublishRequestApi = async (status) => {
  let response = await axios({
    method: "get",
    url: `${ENDPOINTS.getPublishRequest}?status=${status}`,
    headers: commonHeaders(),
  });
  return response;
};

export const updateJournalStatusApi = async (req_id, data) => {
  const formData = new FormData();
  formData.append("approval_status", data.approval_status);

  const response = await axios({
    method: "post",
    url: `${ENDPOINTS.updateJournalStatus}/${req_id}`,
    data: formData,
    headers: commonHeaders(),
  });

  return response;
};

export const joinJournalApi = async (id) => {
  let response = await axios({
    method: "post",
    url: `${ENDPOINTS.joinJournal}/${id}`,
    headers: commonHeaders(),
  });
  return response;
};
export const researchpaperSearchApi = async (filters) => {
  let response = await axios({
    method: "get",
    url: `${ENDPOINTS.researchPaperSearch}/${filters.limit}/${filters.offset}?search=${filters.name}&country=${filters.country}&department=${filters.department}`,
    headers: commonHeaders(),
  });
  return response;
};

export const publisherJoinJournalsApi = async (journalId, reviewerId) => {
  let response = await axios({
    method: "post",
    url: `${ENDPOINTS.publisherJoinJournals}/${journalId}/${reviewerId}`,
    headers: commonHeaders(),
  });
  return response;
};

export const publisherJoinPaperApi = async (journalId, paperId) => {
  let response = await axios({
    method: "post",
    url: `${ENDPOINTS.publisherJoinPaper}/${journalId}/${paperId}`,
    headers: commonHeaders(),
  });
  return response;
};

export const changePublishRequestStatus = async (req_id, data) => {
  const response = await axios({
    method: "post",
    url: `${ENDPOINTS.changePublishRequestStatus}/${req_id}`,
    data: data,
    headers: commonHeaders(),
  });

  return response;
};
export const getResearchpaperApi = async () => {
  const response = await axios({
    method: "get",
    url: ENDPOINTS.getresearchPaper,
    headers: commonHeaders(),
  });

  return response.data;
};

export const changePasswordApi = async (data) => {
  const response = await axios({
    method: "post",
    url: ENDPOINTS.changePassword,
    data: data,
    headers: commonHeaders(),
  });

  return response;
};

export const deleteResearchPaperApi = async (id) => {
  let response = await axios({
    method: "get",
    url: `${ENDPOINTS.deleteResearchPaper}/${id}`,
    headers: commonHeaders(),
  });
  return response;
};

export const updateResearchPaperApi = async (researchPaperId, payload) => {
  let response = await axios({
    method: "post",
    url: `${ENDPOINTS.updateResearchPaper}/${researchPaperId}`,
    data: payload,
    headers: commonHeaders(),
  });
  return response;
};

export const joinedAllJournalsApi = async () => {
  let response = await axios({
    method: "get",
    url: `${ENDPOINTS.joinedAllJournals}`,

    headers: commonHeaders(),
  });
  return response;
};
export const leaveJournalApi = async (request_id) => {
  let response = await axios({
    method: "post",
    url: `${ENDPOINTS.leaveJournals}/${request_id}`,

    headers: commonHeaders(),
  });
  return response;
};

export const getResearchPaperByIdApi = async (researchPaperId) => {
  let response = await axios({
    method: "get",
    url: `${ENDPOINTS.getResearchPaperById}/${researchPaperId}`,
    headers: commonHeaders(),
  });

  console.log("Update response:", response.data);
  return response;
};

export const assignRequestToReviewerApi = async (reviewerId, prId) => {
  let response = await axios({
    method: "post",
    url: `${ENDPOINTS.assignRequestToReviewer}/${reviewerId}/${prId}`,
    headers: commonHeaders(),
  });
  return response;
};

export const getJournalDetailsById = async (journal_id) => {
  let response = await axios({
    method: "get",
    url: `${ENDPOINTS.getJournalDetailsById}/${journal_id}`,
  });
  return response;
};

export const getApprovedPublicationByUserIdApi = async (user_id) => {
  let response = await axios({
    method: "get",
    url: `${ENDPOINTS.getApprovedPublicationByUserId}/${user_id}`,
  });
  return response;
};

export const journalPublishedPapersApi = async (journal_id) => {
  let response = await axios({
    method: "get",
    url: `${ENDPOINTS.journalPublishedPapers}/${journal_id}`,
  });
  return response;
};

export const getPublicationByIdWebApi = async (id) => {
  let response = await axios({
    method: "get",
    url: `${ENDPOINTS.getPublicationByIdWeb}/${id}`,
    // headers: commonHeaders(),
  });
  return response;
};

export const getAssignedRequestApi = async () => {
  let response = await axios({
    method: "get",
    url: `${ENDPOINTS.getAssignedRequest}`,
    headers: commonHeaders(),
  });
  return response;
};

export const updateRemarksApi = async (id, data) => {
  const response = await axios({
    method: "post",
    url: `${ENDPOINTS.updateRemarks}/${id}`,
    data: data,
    headers: commonHeaders(),
  });
  return response;
};

export const razorpayApi = async (id) => {
  const response = await axios({
    method: "post",
    url: `${ENDPOINTS.razorpay}/${id}`,
    headers: commonHeaders(),
  });
  return response;
};
export const getMyReviewsApi = async () => {
  let response = await axios({
    method: "get",
    url: `${ENDPOINTS.getMyReviews}`,
    headers: commonHeaders(),
  });
  return response;
};

export const forgetPasswordApi = async (email) => {
  let response = await axios({
    method: "post",
    data: { email: email },
    url: ENDPOINTS.forgetPassword,
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response;
};

export const resetPasswordApi = async (newPassword, token) => {
  console.log(token);
  let response = await axios({
    method: "post",
    data: { new_password: newPassword },
    url: ENDPOINTS.resetPassword,
    headers: { Authorization: token, "Content-Type": "multipart/form-data" },
  });
  return response;
};
